// extracted by mini-css-extract-plugin
module.exports = {"saleStage":"SaleStage_saleStage__MHV04","stage":"SaleStage_stage__aUZBd"};